import React from 'react';
import {
  ListingLabelContext,
  ExternalAuthContext,
  BuyerAgreementContextProvider,
} from 'contexts';
import { featureEnabled } from 'utils';
import AppointmentBookingExternal from './AppointmentBookingExternal';
import AppointmentBookingInternal from './AppointmentBookingInternal';

const AppointmentBooking = props => {
  // props passed in through the apointmentbooking.module.js
  // extAuth and apointmentDetails were part of the bindings
  const { extAuth, $location } = props;

  if (extAuth) {
    return (
      <ExternalAuthContext.Provider
        value={{
          auth: extAuth,
        }}
      >
        <AppointmentBookingExternal {...props} />
      </ExternalAuthContext.Provider>
    );
  }

  const parsedPaths = ($location?.$$path || '').split('/');
  // TODO: to be deleted when removing FF, and also, to be deleted when all other booking screen uses new one.
  if (
    featureEnabled('showingsMadeEasyPhase2Feature') &&
    parsedPaths?.[1] === 'listing' &&
    parsedPaths?.[3] === 'appointments' &&
    parsedPaths?.[4] === 'book'
  )
    return null;
  return <AppointmentBookingInternal {...props} />;
};

const AppointmentBookingContextWrapped = props => (
    <BuyerAgreementContextProvider>
      <ListingLabelContext.Provider
        value={{
          labelOverrideMap: props.$rootScope.labelOverrideMap,
          getAvailability: props.$rootScope.getAvailability,
          getLabel: props.$rootScope.getLabel,
        }}
      >
        <AppointmentBooking {...props} />
      </ListingLabelContext.Provider>
    </BuyerAgreementContextProvider>
  );

export default AppointmentBookingContextWrapped;
